(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["drop-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initDropPage(root) {
      if (root.getAttribute('data-launched') === 'true') return;

      var dropDateAttr = root.getAttribute('data-drop-date');
      if (!dropDateAttr) return;
      var dropTime = new Date(dropDateAttr).getTime();
      if (isNaN(dropTime)) return;

      var preLaunch = root.querySelector('.drop-page__pre-launch');
      var postLaunch = root.querySelector('.drop-page__launched');
      var digits = {
        days: root.querySelector('[data-unit="days"]'),
        hours: root.querySelector('[data-unit="hours"]'),
        minutes: root.querySelector('[data-unit="minutes"]'),
        seconds: root.querySelector('[data-unit="seconds"]'),
      };

      function pad(n) { return n < 10 ? '0' + n : '' + n; }

      function swapToLaunched() {
        if (preLaunch) preLaunch.hidden = true;
        if (postLaunch) postLaunch.hidden = false;
        root.setAttribute('data-launched', 'true');
        try { window.location.reload(); } catch (e) {}
      }

      function tick() {
        var diff = dropTime - Date.now();
        if (diff <= 0) {
          if (digits.days) digits.days.textContent = '00';
          if (digits.hours) digits.hours.textContent = '00';
          if (digits.minutes) digits.minutes.textContent = '00';
          if (digits.seconds) digits.seconds.textContent = '00';
          swapToLaunched();
          clearInterval(interval);
          return;
        }
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        if (digits.days) digits.days.textContent = pad(d);
        if (digits.hours) digits.hours.textContent = pad(h);
        if (digits.minutes) digits.minutes.textContent = pad(m);
        if (digits.seconds) digits.seconds.textContent = pad(s);
      }

      tick();
      var interval = setInterval(tick, 1000);
    }

    document.querySelectorAll('.drop-page').forEach(initDropPage);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drop-split-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initDropHero(root) {
      var dropDateAttr = root.getAttribute('data-drop-date');
      if (!dropDateAttr) return;

      var dropTime = new Date(dropDateAttr).getTime();
      if (isNaN(dropTime)) return;

      var preLaunch = root.querySelector('.drop-split-hero__pre-launch');
      var postLaunch = root.querySelector('.drop-split-hero__launched');
      var digits = {
        days: root.querySelector('[data-unit="days"]'),
        hours: root.querySelector('[data-unit="hours"]'),
        minutes: root.querySelector('[data-unit="minutes"]'),
        seconds: root.querySelector('[data-unit="seconds"]'),
      };

      function pad(n) {
        return n < 10 ? '0' + n : '' + n;
      }

      function swapToLaunched() {
        if (preLaunch) preLaunch.hidden = true;
        if (postLaunch) postLaunch.hidden = false;
        root.setAttribute('data-launched', 'true');
      }

      function tick() {
        var diff = dropTime - Date.now();
        if (diff <= 0) {
          if (digits.days) digits.days.textContent = '00';
          if (digits.hours) digits.hours.textContent = '00';
          if (digits.minutes) digits.minutes.textContent = '00';
          if (digits.seconds) digits.seconds.textContent = '00';
          swapToLaunched();
          clearInterval(interval);
          return;
        }
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        if (digits.days) digits.days.textContent = pad(d);
        if (digits.hours) digits.hours.textContent = pad(h);
        if (digits.minutes) digits.minutes.textContent = pad(m);
        if (digits.seconds) digits.seconds.textContent = pad(s);
      }

      tick();
      var interval = setInterval(tick, 1000);
    }

    document.querySelectorAll('.drop-split-hero').forEach(initDropHero);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
